import PlatformActions from './PlatformActions'

export default class YGGDRASILSLOTActions extends PlatformActions {
  constructor(formData) {
    super(formData)
    this.formData = formData

    this.constantTxnData = {
      platform: 'YGGDRASIL',
      gameType: 'SLOT',
      gameCode: 'YGG-SLOT-005',
    }

    this.gameName = 'Big Bucks Bandits MegaWays'
  }

  getBetMessage(txnList) {
    const { currency, supportPremium } = this.formData

    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      betTime,
      betAmount,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `YG001-${roundId}300001_YG001-w${wagerId}300000`, // YG001-2511180401180300001_YG001-w2511180401180300000 251118 0401 180 300001 251118 0401 180
      roundId: `YG001-${roundId}300001`, // YG001-2511180401180300001
      betType: null,
      currency,
      betTime, // 2025-11-18T12:01:30.000+08:00
      betAmount,
      jackpotBetAmount: 0,
      gameInfo: {
        betType: '1',
      },
      ...(supportPremium && { isPremium: false }),
    }))

    const message = {
      action: 'bet',
      txns,
    }

    return JSON.stringify(message)
  }

  getSettleMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
      updateTime,
      betTime,
      turnover,
      betAmount,
      winAmount,
      isEndRound = true,
    }) => ({
      ...this.constantTxnData,
      gameName: this.gameName,
      userId,
      platformTxId: `YG001-${roundId}300001_YG001-${wagerId}300000`, // YG0YG001-2511180401180300001_YG001-2511180401290300000
      refPlatformTxId: null,
      settleType: 'roundId',
      updateTime, // 2025-11-18T12:01:30.089+08:00
      roundId: `YG001-${roundId}300001`, // YG001-2511180401180300001
      betType: null,
      betTime,
      txTime: betTime,
      turnover,
      betAmount,
      winAmount,
      jackpotWinAmount: 0,
      gameInfo: {
        betType: '1',
        isEndRound: `${isEndRound}`,
      },
    }))

    const message = {
      action: 'settle',
      txns,
    }

    return JSON.stringify(message)
  }

  getCancelBetMessage(txnList) {
    const txns = txnList.map(({
      userId,
      roundId,
      wagerId,
    }) => ({
      ...this.constantTxnData,
      userId,
      platformTxId: `YG001-${roundId}300001_YG001-w${wagerId}300000`,
      roundId: `YG001-${roundId}300001`,
      gameInfo: {
        betType: '1',
      },
    }))

    const message = {
      action: 'cancelBet',
      txns,
    }

    return JSON.stringify(message)
  }
}
